import { OnboardingModalDto, MultiVariantsOnboardingModalDto } from 'types/dtos'
import { OnboardingModalModel, MultiVariantsOnboardingModalModel } from 'types/models'

export const transformOnboardingModal = ({
  name,
  steps,
}: OnboardingModalDto): OnboardingModalModel => ({
  name,
  steps: steps.map(step => ({
    name: step.name,
    title: step.title,
    body: step.body,
    imageUrl: step.image_url,
    video: step.video && {
      vertical: {
        formats: step.video.vertical.formats,
        imageUrl: step.video.vertical.image_url,
      },
    },
  })),
})

export const transformMultiVariantsOnboardingModal = ({
  name,
  actions,
  steps,
}: MultiVariantsOnboardingModalDto): MultiVariantsOnboardingModalModel => ({
  name,
  actions,
  steps: steps.map(step => ({
    name: step.name,
    title: step.title,
    body: step.body,
    imageUrl: step.image_url,
    video: step.video && {
      vertical: {
        formats: step.video.vertical.formats,
        imageUrl: step.video.vertical.image_url,
      },
    },
  })),
})
